import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../styles/main.scss';

const QuestionComponent = (props) => (
  <div>
    <h2 className="h2-alt">
      {props.currentQuestion.question}
      (
      {props.currentQuestionNumber}
      /
      {props.questionCount}
      )
    </h2>
    <div className={`${styles.answerButtons} offset-bottom`}>
      <button
        className="btn btn-default"
        onClick={() => props.onSaveAnswer(0)}
      >
        {props.currentQuestion.answers[0].label}
      </button>
      <button
        className="btn btn-default"
        onClick={() => props.onSaveAnswer(1)}
      >
        {props.currentQuestion.answers[1].label}
      </button>
      <button
        className="btn btn-default"
        onClick={() => props.onSaveAnswer(2)}
      >
        {props.currentQuestion.answers[2].label}
      </button>
    </div>
    {props.hasPreviousQuestion && (
      <a onClick={() => props.onReturnBack()}>
        Back
      </a>
    )}
  </div>
);

QuestionComponent.propTypes = {
  currentQuestion: PropTypes.shape({
    answers: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
    })).isRequired,
    question: PropTypes.string.isRequired,
  }).isRequired,
  currentQuestionNumber: PropTypes.number.isRequired,
  hasPreviousQuestion: PropTypes.bool.isRequired,
  onReturnBack: PropTypes.func.isRequired,
  onSaveAnswer: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
};

export default QuestionComponent;
